const vehicleTypes = [
  { Id: 1, Name: "Motorcycle" },
  { Id: 2, Name: "Passenger Car" },
  { Id: 3, Name: "Truck" },
  { Id: 5, Name: "Bus" },
  { Id: 6, Name: "Trailer" },
  {
    Id: 7,
    Name: "Multipurpose Passenger Vehicle (MPV)",
  },
  { Id: 9, Name: "Low Speed Vehicle (LSV)" },
  { Id: 10, Name: "Incomplete Vehicle" },
  { Id: 13, Name: "Off Road Vehicle" },
].map((m) => ({
  label: m.Name,
  value: `${m.Id}`,
}));

export default vehicleTypes;
